import React, { useContext } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import PrivilegeContext from "../context/privilege";
import { useHistory } from "react-router-dom";
const Modalcarpack = ({ isOpen, onCancel }) => {
  const history = useHistory();
  const { menuItems } = useContext(PrivilegeContext);
  // const history = useHistory();
  // const url = "https://www.canva.com/design/DAE-OYNsUn0/JteKq93jmAwVnGtlFNe2RQ/view?utm_content=DAE-OYNsUn0&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink#3";
  //src="https://api-vendor.advanceagro.net/wsvis/image/slide1.jpg" alt="avatar_img"

const handleClick = (url) => {
   const urlGoBack = { pathname: "/"+url };
   setTimeout(history.push(urlGoBack), 1000);
}
// console.log(menuItems)

  return (
    <div>
      <Modal
        className="modal-dialog"
        isOpen={isOpen}
        toggle={onCancel}
        size="xl"
        centered
      >
        <ModalBody>
          <div>
            {menuItems &&
            menuItems.length > 0 &&
            menuItems[0].id === 1 &&
            menuItems[0].subMenus &&
            menuItems[0].subMenus.length > 0 &&
            menuItems[0].subMenus[0].autoid > 25 ? (
              <>
                <img
                  src={
                    "carpack.jpeg"
                  }
                  alt="avatar_img"
                  style={{
                    width: "100%",
                    // maxHeight: 1020,
                  }}
                 
                />
              </>
            ) : <img
            src={
              "carpack.jpeg"
            }
            alt="avatar_img"
            style={{
              width: "100%",
              maxHeight: "100%",
              cursor: "pointer" 
             
            }}
            onClick ={() =>handleClick ("manual3")}
          />}
          </div>
        </ModalBody>
        <ModalFooter></ModalFooter>
        <div className="position-absolute top-100 start-50 translate-middle ">
          <div className="row d-flex justify-content-center">
            <Button color="danger" onClick={onCancel}>
              ปิด
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Modalcarpack;
